import { ConnectButton } from '@rainbow-me/rainbowkit'
import { HealthStrip } from './components/HealthStrip'
import { SwapCard } from './components/SwapCard'
import { walletConnectAvailable } from './lib/wagmi'

export function App() {
  return (
    <div className="page">
      <header className="topbar">
        <div className="brand">
          <span className="brand-mark">◆</span>
          <div>
            <strong>SparkDEX</strong>
            <span className="muted"> router</span>
          </div>
        </div>
        <div className="topbar-right">
          <HealthStrip />
          <ConnectButton showBalance={false} />
        </div>
      </header>

      <main className="main">
        {!walletConnectAvailable && (
          <div className="notice notice-warn">
            <div className="notice-title">WalletConnect is off</div>
            <p className="notice-body">
              No <code>VITE_WALLETCONNECT_PROJECT_ID</code> is set, so mobile and WalletConnect wallets are hidden
              rather than shown and made to fail. Browser wallets — Rabby, MetaMask — still work.
            </p>
          </div>
        )}
        <SwapCard />
      </main>

      <footer className="footer">
        <span>
          Quotes come from <code>OmegaQuoter</code> on chain, through the router API. Nothing is simulated in this
          browser.
        </span>
      </footer>
    </div>
  )
}
